import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Section, Reveal } from './Section';
const rows = [{
  situation: 'No sabés cuánto arriesgar',
  without: 'Entrás a ciegas',
  with: 'Calculadora de riesgo lista'
}, {
  situation: 'Encontrás una estrategia online',
  without: 'No sabés si funciona',
  with: 'Backtesting paso a paso'
}, {
  situation: 'Dudás si el método funciona',
  without: 'Confiás sin evidencia',
  with: '5 casos reales analizados'
}, {
  situation: 'Querés aprender pero no podés pagar $500 USD',
  without: 'Quedás afuera',
  with: 'Mismo método, sin barrera'
}];
export function ComparisonTable() {
  return <Section className="bg-ink-950" data-id="element-31" data-mp="3dcmh3injon93">
      <Reveal data-id="element-32" data-mp="3dbkt6dlfk69y">
        <h2 className="font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl" data-id="element-33" data-mp="3dbb54vjy496w">
          Con y sin Capital Consciente
        </h2>
      </Reveal>

      <Reveal delay={0.08} data-id="element-34" data-mp="21zk04mhj9voe">
        <div className="mt-8 overflow-hidden rounded-2xl border border-white/10" data-id="element-35" data-mp="21vmhe1yvb651">
          {/* header */}
          <div className="grid grid-cols-3 border-b border-white/10 bg-ink-850 text-xs font-semibold uppercase tracking-wide text-gray-400 sm:text-sm" data-id="element-36" data-mp="29vtvdbrkf3pu">
            <div className="p-3 sm:p-4" data-id="element-37" data-mp="2nx69dhn60v93">Tu situación</div>
            <div className="border-l border-white/10 p-3 sm:p-4" data-id="element-38" data-mp="2iws241te1pc4">Sin CC</div>
            <div className="border-l border-white/10 bg-brand-soft p-3 text-brand sm:p-4" data-id="element-39" data-mp="2iyuyd3l4wepa">
              Con CC
            </div>
          </div>

          {rows.map((r, i) => <div key={r.situation} className={`grid grid-cols-3 text-sm ${i % 2 === 0 ? 'bg-ink-900' : 'bg-ink-950'}`} data-id="element-40" data-mp="2sufy0v2qd2vv" data-mpi={i}>
              <div className="p-3 font-medium text-gray-200 sm:p-4" data-id="element-41" data-mp="31nrtf9ocvb8k">
                {r.situation}
              </div>
              <div className="flex items-start gap-2 border-l border-white/10 p-3 text-gray-400 sm:p-4" data-id="element-42" data-mp="3ghwd2w0zj14v">
                <XIcon className="mt-0.5 h-4 w-4 flex-none text-red-400/70" data-id="element-43" data-mp="3iodv90wnc1q0" />
                <span data-id="element-44" data-mp="3iq70cbrm2dvw">{r.without}</span>
              </div>
              <div className="flex items-start gap-2 border-l border-white/10 bg-brand-soft/40 p-3 text-gray-100 sm:p-4" data-id="element-45" data-mp="3nmp2d3vk3y4j">
                <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand" data-id="element-46" data-mp="3skz27rs87mwh" />
                <span data-id="element-47" data-mp="18xngt3av0tm">{r.with}</span>
              </div>
            </div>)}
        </div>
      </Reveal>
    </Section>;
}